module.exports = __webpack_public_path__ + "img/form-lower-title-mobile.8d18a3bb.png";